<!-- <div class="main-wrapper">
  <div class="logo-container">
    <img src="../../../assets/logo.png" alt="DOQMA" class="logo-img">
  </div>

  <div class="plans-grid" style="display: flex; gap: 24px; justify-content: center; align-items: stretch; max-width: 1100px; margin: 40px auto; padding: 0 20px;">
    
    <div *ngFor="let plan of plans" class="plan-card" [class.featured]="plan.featured" 
         style="position: relative; background: #111111; border: 1px solid #222222; border-radius: 24px; padding: 45px 24px 30px 24px; flex: 1; text-align: center; display: flex; flex-direction: column; justify-content: space-between; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); margin-top: 20px;">
      
      <div class="plan-badge" 
           [style.background]="plan.featured ? '#5bc5c5' : '#222222'"
           [style.color]="plan.featured ? '#000000' : '#ffffff'"
           style="position: absolute; top: -16px; left: 50%; transform: translateX(-50%); padding: 6px 20px; border-radius: 20px; font-weight: 700; font-size: 0.85rem; letter-spacing: 1px; text-transform: uppercase; box-shadow: 0 4px 15px rgba(0,0,0,0.4); white-space: nowrap; z-index: 2;">
        {{ plan.name }} <span *ngIf="plan.featured" style="font-size: 0.7rem; margin-left: 4px; opacity: 0.8;">★ BEST VALUE</span>
      </div>

      <div class="price-section" style="margin-bottom: 22px;">
        
        <div class="discount-anchor-row" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 4px;">
          <span class="was-label" style="color: #888888; font-size: 0.85rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">Was</span>
          <span class="original-strike" style="text-decoration: line-through; color: #b5b5b5; font-size: 1.4rem; font-weight: 700; letter-spacing: 0.5px;">
            ₹{{plan.originalPrice}}
          </span>
          
          <span class="discount-tag" 
                [style.background]="plan.duration === 'yr' ? '#ff3b30' : '#ff9500'"
                style="color: #ffffff; font-size: 0.75rem; font-weight: 800; padding: 2px 8px; border-radius: 6px; letter-spacing: 0.5px; box-shadow: 0 2px 8px rgba(0,0,0,0.2);">
            <span *ngIf="plan.duration === 'mo'">30% OFF</span>
            <span *ngIf="plan.duration === '6mo'">40% OFF</span>
            <span *ngIf="plan.duration === 'yr'">50% OFF</span>
          </span>
        </div>

        <div class="main-price" style="font-size: 3.8rem; font-weight: 800; color: #ffffff; line-height: 1; letter-spacing: -1px;">
          ₹{{plan.price}}
        </div>
        
        <div class="duration-breakdown" style="color: #999999; font-size: 0.9rem; margin-top: 10px; font-weight: 500; min-height: 18px;">
          <span *ngIf="plan.duration === 'mo'">billed monthly</span>
          <span *ngIf="plan.duration === '6mo'">for 6 months <b style="color: #5bc5c5; font-weight: 600; margin-left: 2px;">(₹59.00/mo)</b></span>
          <span *ngIf="plan.duration === 'yr'">for 1 year <b style="color: #5bc5c5; font-weight: 600; margin-left: 2px;">(₹41.58/mo)</b></span>
        </div>
      </div>
      
      <div class="value-badge" style="background: #161616; border-radius: 16px; padding: 18px 14px; margin-bottom: 24px; border: 1px solid #222222; box-shadow: inset 0 1px 10px rgba(0,0,0,0.2);">
        <div class="app-count" style="color: #ffffff; font-weight: 800; font-size: 1.5rem; margin-bottom: 4px; letter-spacing: -0.3px;">
          {{plan.totalApps}} Appointments
        </div>
        <div class="unit-price" style="color: #888888; font-size: 0.88rem; font-weight: 500;">
          Just <span style="color: #5bc5c5; font-weight: 700; font-size: 0.95rem;">₹{{plan.unitPrice}}</span> per token
        </div>
      </div>

      <ul class="features-list" style="list-style: none; padding: 0; margin: 0 0 28px 0; text-align: left; flex-grow: 1;">
        <li *ngFor="let feat of plan.features" [class.disabled]="!feat.active"
            [style.opacity]="feat.active ? '1' : '0.3'"
            style="display: flex; align-items: center; gap: 10px; color: #dddddd; font-size: 0.9rem; margin-bottom: 12px; font-weight: 500;">
          <span class="icon-v" *ngIf="feat.active" style="color: #5bc5c5; font-weight: 700;">✓</span>
          <span class="icon-x" *ngIf="!feat.active" style="color: #ff4d4d; font-weight: 700;">✕</span>
          <span [style.text-decoration]="!feat.active ? 'line-through' : 'none'">{{feat.text}}</span>
        </li>
      </ul>

       <div class="bought-count" style="background: rgba(255,152,0,0.08); color: #ff9800; border: 1px solid rgba(255,152,0,0.15); padding: 6px 12px; border-radius: 12px; font-size: 0.8rem; font-weight: 600; display: inline-flex; align-items: center; justify-content: center; gap: 6px; margin: 0 auto 15px auto; width: fit-content;">
        <span>🔥</span> {{plan.bought}} bought today
      </div>

      <button class="btn-select" (click)="openPopup(plan)"
              [style.background]="plan.featured ? '#5bc5c5' : 'transparent'"
              [style.color]="plan.featured ? '#000000' : '#5bc5c5'"
              [style.border]="plan.featured ? 'none' : '2px solid #5bc5c5'"
              style="width: 100%; padding: 14px; border-radius: 14px; font-size: 0.95rem; font-weight: 700; cursor: pointer; letter-spacing: 0.5px; transition: all 0.2s ease; text-transform: uppercase;">
        SELECT PLAN
      </button>
    </div>
  </div>

  <div class="popup-overlay" *ngIf="showPopup">
    <div class="popup-card">
      <button class="close-btn" (click)="closePopup()">✕</button>

      <div *ngIf="popupStep === 1">
        <div style="text-align: left; margin-bottom: 20px;">
          <label class="input-label" style="font-weight: 600; font-size: 0.9rem; color: #aaa;">
            Mobile Number <span style="color:#ff4d4d; font-size: 0.8rem; margin-left: 4px;">[Registered in DOQMA]</span>
          </label>
          <input type="tel" class="input-field" placeholder="DOQMA registered phone-number" [(ngModel)]="userData.phone" maxlength="10" (keypress)="onlyNumbersAllowed($event)">
          
          <div *ngIf="userData.phone && userData.phone.length == 10">
            <label class="input-label" style="font-weight: 600; font-size: 0.9rem; color: #aaa; margin-top: 15px; display: block;">
              Full Name
            </label>
            <input class="input-field" placeholder="Enter your Name" [(ngModel)]="userData.name">
          </div>
        </div>
        
        <button class="btn-select" (click)="nextStep()" [disabled]="isLoading">
          <span *ngIf="!isLoading">CONTINUE</span>
          <span *ngIf="isLoading">PLEASE WAIT...</span>
        </button>

        <div style="margin-top: 25px; border-top: 1px solid #222; padding-top: 15px; text-align: center;">
          <p style="font-size: 0.85rem; margin: 0 0 4px 0; color: #5bc5c5; font-weight: 600; letter-spacing: 0.5px;">
            FOR ANY QUERY CALL US: 7500-800-886 | 7500-800-887
          </p>
          <p style="font-size: 0.7rem; margin: 0; color: #666; font-weight: 500;">
            NOTE: NEW USERS WILL BE REGISTERED AUTOMATICALLY
          </p>
        </div>
      </div>

      <div *ngIf="popupStep === 2">
        <h2 style="color: #5bc5c5; margin-bottom: 5px; font-weight: 700;">Verify Code</h2>
        <p style="color: #888; font-size: 0.85rem; margin-bottom: 25px;">Sent to <span style="color: #fff; font-weight: 600;">+91 {{userData.phone}}</span></p>
        
        <div class="otp-wrapper" style="margin-bottom: 25px;">
          <input 
            type="text" 
            inputmode="numeric" 
            pattern="[0-9]*"
            class="otp-box" 
            placeholder="0000" 
            [(ngModel)]="userData.otp"
            maxlength="4"
            (keypress)="onlyNumbersAllowed($event)">
        </div>

        <button class="btn-select" (click)="nextStep()" [disabled]="isLoading">
          <span *ngIf="!isLoading">VERIFY & PAY</span>
          <span *ngIf="isLoading">VERIFYING...</span>
        </button>
      </div>

      <div *ngIf="popupStep === 3">
        <h2 style="color: #5bc5c5; margin-bottom: 6px; font-weight: 700;">CONFIRM & ACTIVATE</h2>
        <p style="color: #888; font-size: 0.95rem; margin-bottom: 20px;">
          Selected Plan: <span style="color: #fff; font-weight: 700;">{{selectedPlan?.name}}</span>
        </p>
        
        <div style="background: #161616; border: 1px solid #222; padding: 20px; border-radius: 16px; margin-bottom: 25px; text-align: left;">
          <p style="color: #aaa; margin: 0 0 8px 0; font-size: 0.9rem;">Subscriber: <b style="color: #fff;">{{userData.name}}</b></p>
          <p style="color: #aaa; margin: 0 0 8px 0; font-size: 0.9rem;">Mobile: <b style="color: #fff;">+91 {{userData.phone}}</b></p>
          <p style="color: #aaa; margin: 0; font-size: 0.9rem;">Total Payable: <b style="color: #5bc5c5; font-size: 1.1rem;">₹{{selectedPlan?.price}}</b></p>
        </div>

        <button class="btn-select" (click)="payWithRazorpay()" [disabled]="isLoading">
          <span *ngIf="!isLoading">SECURE PAY NOW</span>
          <span *ngIf="isLoading">INITIALIZING GATEWAY...</span>
        </button>
      </div>

      <div *ngIf="popupStep === 4">
        <div style="font-size: 5rem; color: #5bc5c5; margin-bottom: 10px; line-height: 1;">✓</div>
        <h2 style="color: #fff; margin-bottom: 25px; font-weight: 700;">Plan Active!</h2>
        <button class="btn-select" (click)="closePopup()">DONE</button>
      </div>
    </div>
  </div>
</div>
 -->


 <!-- New code with order creation and payments  -->

 <div class="main-wrapper">
  <div class="logo-container">
    <img src="../../../assets/logo.png" alt="DOQMA" class="logo-img">
  </div>

  <div class="plans-grid" style="display: flex; gap: 24px; justify-content: center; align-items: stretch; max-width: 1100px; margin: 40px auto; padding: 0 20px;">
    
    <div *ngFor="let plan of plans" class="plan-card" [class.featured]="plan.featured" 
         style="position: relative; background: #111111; border: 1px solid #222222; border-radius: 24px; padding: 45px 24px 30px 24px; flex: 1; text-align: center; display: flex; flex-direction: column; justify-content: space-between; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); margin-top: 20px;">
      
      <div class="plan-badge" 
           [style.background]="plan.featured ? '#5bc5c5' : '#222222'"
           [style.color]="plan.featured ? '#000000' : '#ffffff'"
           style="position: absolute; top: -16px; left: 50%; transform: translateX(-50%); padding: 6px 20px; border-radius: 20px; font-weight: 700; font-size: 0.85rem; letter-spacing: 1px; text-transform: uppercase; box-shadow: 0 4px 15px rgba(0,0,0,0.4); white-space: nowrap; z-index: 2;">
        {{ plan.name }} <span *ngIf="plan.featured" style="font-size: 0.7rem; margin-left: 4px; opacity: 0.8;">★ BEST VALUE</span>
      </div>

      <div class="price-section" style="margin-bottom: 22px;">
        
        <div class="discount-anchor-row" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 4px;">
          <span class="was-label" style="color: #888888; font-size: 0.85rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">Was</span>
          <span class="original-strike" style="text-decoration: line-through; color: #b5b5b5; font-size: 1.4rem; font-weight: 700; letter-spacing: 0.5px;">
            ₹{{plan.originalPrice}}
          </span>
          
          <span class="discount-tag" 
                [style.background]="plan.duration === 'yr' ? '#ff3b30' : '#ff9500'"
                style="color: #ffffff; font-size: 0.75rem; font-weight: 800; padding: 2px 8px; border-radius: 6px; letter-spacing: 0.5px; box-shadow: 0 2px 8px rgba(0,0,0,0.2);">
            <span *ngIf="plan.duration === 'mo'">30% OFF</span>
            <span *ngIf="plan.duration === '6mo'">40% OFF</span>
            <span *ngIf="plan.duration === 'yr'">50% OFF</span>
          </span>
        </div>

        <div class="main-price" style="font-size: 3.8rem; font-weight: 800; color: #ffffff; line-height: 1; letter-spacing: -1px;">
          ₹{{plan.price}}
        </div>
        
        <div class="duration-breakdown" style="color: #999999; font-size: 0.9rem; margin-top: 10px; font-weight: 500; min-height: 18px;">
          <span *ngIf="plan.duration === 'mo'">billed monthly</span>
          <span *ngIf="plan.duration === '6mo'">for 6 months <b style="color: #5bc5c5; font-weight: 600; margin-left: 2px;">(₹59.00/mo)</b></span>
          <span *ngIf="plan.duration === 'yr'">for 1 year <b style="color: #5bc5c5; font-weight: 600; margin-left: 2px;">(₹41.58/mo)</b></span>
        </div>
      </div>
      
      <div class="value-badge" style="background: #161616; border-radius: 16px; padding: 18px 14px; margin-bottom: 24px; border: 1px solid #222222; box-shadow: inset 0 1px 10px rgba(0,0,0,0.2);">
        <div class="app-count" style="color: #ffffff; font-weight: 800; font-size: 1.5rem; margin-bottom: 4px; letter-spacing: -0.3px;">
          {{plan.totalApps}} Appointments
        </div>
        <div class="unit-price" style="color: #888888; font-size: 0.88rem; font-weight: 500;">
          Just <span style="color: #5bc5c5; font-weight: 700; font-size: 0.95rem;">₹{{plan.unitPrice}}</span> per token
        </div>
      </div>

      <ul class="features-list" style="list-style: none; padding: 0; margin: 0 0 28px 0; text-align: left; flex-grow: 1;">
        <li *ngFor="let feat of plan.features" [class.disabled]="!feat.active"
            [style.opacity]="feat.active ? '1' : '0.3'"
            style="display: flex; align-items: center; gap: 10px; color: #dddddd; font-size: 0.9rem; margin-bottom: 12px; font-weight: 500;">
          <span class="icon-v" *ngIf="feat.active" style="color: #5bc5c5; font-weight: 700;">✓</span>
          <span class="icon-x" *ngIf="!feat.active" style="color: #ff4d4d; font-weight: 700;">✕</span>
          <span [style.text-decoration]="!feat.active ? 'line-through' : 'none'">{{feat.text}}</span>
        </li>
      </ul>

       <div class="bought-count" style="background: rgba(255,152,0,0.08); color: #ff9800; border: 1px solid rgba(255,152,0,0.15); padding: 6px 12px; border-radius: 12px; font-size: 0.8rem; font-weight: 600; display: inline-flex; align-items: center; justify-content: center; gap: 6px; margin: 0 auto 15px auto; width: fit-content;">
        <span>🔥</span> {{plan.bought}} bought today
      </div>

      <button class="btn-select" (click)="openPopup(plan)"
              [style.background]="plan.featured ? '#5bc5c5' : 'transparent'"
              [style.color]="plan.featured ? '#000000' : '#5bc5c5'"
              [style.border]="plan.featured ? 'none' : '2px solid #5bc5c5'"
              style="width: 100%; padding: 14px; border-radius: 14px; font-size: 0.95rem; font-weight: 700; cursor: pointer; letter-spacing: 0.5px; transition: all 0.2s ease; text-transform: uppercase;">
        SELECT PLAN
      </button>
    </div>
  </div>

  <div class="popup-overlay" *ngIf="showPopup">
    <div class="popup-card">
      <button class="close-btn" (click)="closePopup()">✕</button>

      <div *ngIf="popupStep === 1">
        <div style="text-align: left; margin-bottom: 20px;">
          <label class="input-label" style="font-weight: 600; font-size: 0.9rem; color: #aaa;">
            Mobile Number <span style="color:#ff4d4d; font-size: 0.8rem; margin-left: 4px;">[Registered in DOQMA]</span>
          </label>
          <input type="tel" class="input-field" placeholder="DOQMA registered phone-number" [(ngModel)]="userData.phone" maxlength="10" (keypress)="onlyNumbersAllowed($event)">
          
          <div *ngIf="userData.phone && userData.phone.length == 10">
            <label class="input-label" style="font-weight: 600; font-size: 0.9rem; color: #aaa; margin-top: 15px; display: block;">
              Full Name
            </label>
            <input class="input-field" placeholder="Enter your Name" [(ngModel)]="userData.name">
          </div>
        </div>
        
        <button class="btn-select" (click)="nextStep()" [disabled]="isLoading">
          <span *ngIf="!isLoading">CONTINUE</span>
          <span *ngIf="isLoading">PLEASE WAIT...</span>
        </button>

        <div style="margin-top: 25px; border-top: 1px solid #222; padding-top: 15px; text-align: center;">
          <p style="font-size: 0.85rem; margin: 0 0 4px 0; color: #5bc5c5; font-weight: 600; letter-spacing: 0.5px;">
            FOR ANY QUERY CALL US: 7500-800-886 | 7500-800-887
          </p>
          <p style="font-size: 0.7rem; margin: 0; color: #666; font-weight: 500;">
            NOTE: NEW USERS WILL BE REGISTERED AUTOMATICALLY
          </p>
        </div>
      </div>

      <div *ngIf="popupStep === 2">
        <h2 style="color: #5bc5c5; margin-bottom: 5px; font-weight: 700;">Verify Code</h2>
        <p style="color: #888; font-size: 0.85rem; margin-bottom: 25px;">Sent to <span style="color: #fff; font-weight: 600;">+91 {{userData.phone}}</span></p>
        
        <div class="otp-wrapper" style="margin-bottom: 25px;">
          <input 
            type="text" 
            inputmode="numeric" 
            pattern="[0-9]*"
            class="otp-box" 
            placeholder="0000" 
            [(ngModel)]="userData.otp"
            maxlength="4"
            (keypress)="onlyNumbersAllowed($event)">
        </div>

        <button class="btn-select" (click)="nextStep()" [disabled]="isLoading">
          <span *ngIf="!isLoading">VERIFY & PAY</span>
          <span *ngIf="isLoading">VERIFYING...</span>
        </button>
      </div>

      <div *ngIf="popupStep === 3">
        <h2 style="color: #5bc5c5; margin-bottom: 6px; font-weight: 700;">CONFIRM & ACTIVATE</h2>
        <p style="color: #888; font-size: 0.95rem; margin-bottom: 20px;">
          Selected Plan: <span style="color: #fff; font-weight: 700;">{{selectedPlan?.name}}</span>
        </p>
        
        <div style="background: #161616; border: 1px solid #222; padding: 20px; border-radius: 16px; margin-bottom: 25px; text-align: left;">
          <p style="color: #aaa; margin: 0 0 8px 0; font-size: 0.9rem;">Subscriber: <b style="color: #fff;">{{userData.name}}</b></p>
          <p style="color: #aaa; margin: 0 0 8px 0; font-size: 0.9rem;">Mobile: <b style="color: #fff;">+91 {{userData.phone}}</b></p>
          <p style="color: #aaa; margin: 0; font-size: 0.9rem;">Total Payable: <b style="color: #5bc5c5; font-size: 1.1rem;">₹{{selectedPlan?.price}}</b></p>
        </div>

        <button class="btn-select" (click)="payWithRazorpay()" [disabled]="isLoading">
          <span *ngIf="!isLoading">SECURE PAY NOW</span>
          <span *ngIf="isLoading">INITIALIZING GATEWAY...</span>
        </button>
      </div>

     <div *ngIf="popupStep === 4" style="padding: 20px 10px;">
        <div style="font-size: 5.5rem; color: #5bc5c5; margin-bottom: 15px; line-height: 1; animation: scaleUp 0.4s ease;">✓</div>
        
        <h2 style="color: #fff; margin-bottom: 8px; font-weight: 800; letter-spacing: -0.5px; text-transform: uppercase;">
          Payment Successful!
        </h2>
        
        <p style="color: #888; font-size: 0.95rem; margin-bottom: 25px; line-height: 1.5;">
          Thank you, <span style="color: #fff; font-weight: 600;">{{userData.name}}</span>. Your account tier state has been updated successfully.
        </p>

        <div style="background: rgba(91, 197, 197, 0.06); border: 1px dashed rgba(91, 197, 197, 0.3); padding: 22px; border-radius: 18px; margin-bottom: 30px; text-align: left;">
          <h4 style="color: #5bc5c5; margin: 0 0 12px 0; font-size: 0.85rem; font-weight: 700; letter-spacing: 1px; text-transform: uppercase;">
            ACTIVATED PACKAGE DETAILS
          </h4>
          <p style="color: #eee; margin: 0 0 8px 0; font-size: 0.95rem; font-weight: 500;">
            Plan Tier: <b style="color: #fff; float: right;">{{selectedPlan?.name}} Subscription</b>
          </p>
          <p style="color: #eee; margin: 0 0 8px 0; font-size: 0.95rem; font-weight: 500;">
            Quota Alotted: <b style="color: #5bc5c5; float: right;">{{selectedPlan?.totalApps}} Appointments</b>
          </p>
          <p style="color: #eee; margin: 0; font-size: 0.95rem; font-weight: 500;">
            Registered Mobile: <b style="color: #fff; float: right;">+91 {{userData.phone}}</b>
          </p>
        </div>
        <button class="btn-select" (click)="openApp()" style="box-shadow: 0 4px 15px rgba(91,197,197,0.2);">
          START USING APPOINTMENTS
        </button>
        <!-- <button class="btn-select" (click)="closePopup()" style="box-shadow: 0 4px 15px rgba(91,197,197,0.2);">
          START USING APPOINTMENTS
        </button> -->
      </div>
    </div>
  </div>
</div>
